import { IRootState } from "app/model"
import { ICampaignFilters } from "campaign/model"
import React from "react"
import { connect } from "react-redux"
import { isPhoneScreen } from "ui/tools/responsive"
import { Filters } from "./Filters"

interface IMyForecastFiltersProps {
  isExpanded: boolean
  filters: ICampaignFilters
  isPhone: boolean
}

const MyForecastFiltersFn = ({ isExpanded, filters, isPhone }: IMyForecastFiltersProps): JSX.Element => (
  <Filters isExpanded={isExpanded} filters={filters} isForecast isDspDeal={false} isPhone={isPhone} />
)

export const MyForecastFilters = connect(
  (state: IRootState): IMyForecastFiltersProps => ({
    isExpanded: state.campaign.forecastList.isFilterExpanded,
    filters: state.campaign.forecastList.filters,
    isPhone: isPhoneScreen(state)
  })
)(MyForecastFiltersFn)
